<script>
	import ButtonInput from '../atoms/ButtonInput.svelte';
	import FileInput from '../atoms/FileInput.svelte';
	import Text from '../atoms/text.svelte';

	export let onClick;
</script>

<form>
	<FileInput id="file" text="Media à envoyer : " />
	<ButtonInput bind:onClick value="Envoyer" />
</form>

<Text txt="Par soucis de performance, il n'est pas possible de charger plus de 5 images à la fois." />

<style>
	form {
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>
